export default __webpack_public_path__ + "assets/devices-432dfff.svg";